<template>
  <footer class="bg-gray-600">
    <Container
      class="pt-20 lg:pt-56"
      data-nosnippet>
      <div class="grid w-full justify-items-center pb-10 lg:grid-cols-3 lg:justify-items-start lg:pb-16">
        <div>
          <SvgOutfit7Logo class="h-[30px] text-white" />
          <ButtonBase
            :label="contactCTA.title"
            class="mt-10"
            type="filled"
            :href="contactCTA.href" />
        </div>
        <nav
          class="mt-12 grid justify-center space-y-6 text-center text-base lg:mt-0 lg:justify-items-start lg:text-left lg:text-2xl">
          <FooterLink
            v-for="link in navigation"
            :key="link.id"
            :to="link.url"
            class="after:h-0.5">
            {{ link.title }}
          </FooterLink>
        </nav>
        <div class="mt-12 lg:ml-auto lg:mt-0">
          <ButtonBase
            :label="partnersCTA.title"
            class="w-full"
            type="outline"
            :href="partnersCTA.href" />
          <!-- TODO: Uncomment after republishing the page -->
          <!-- <ButtonBase :label="venturesCTA.title"
           class="mt-6 w-full"
           type="outline"
           :href="venturesCTA.href"
           /> -->
          <p class="mt-12 w-full text-center text-sm text-gray-100 lg:w-auto lg:text-left">Check also</p>
          <ButtonBase
            icon="top-right"
            class="mt-4 lg:mt-5"
            href="https://www.aurion11.com/"
            label="Visit AURION11"
            type="gradient"
            @click="handleA11Click">
            <NuxtImg
              src="https://cdn.outfit7.com/web/outfit7.com/aurion11-logo.png"
              alt="AURION11 Logo"
              height="32"
              sizes="90px" />
          </ButtonBase>
        </div>
      </div>
      <FooterSocial />
    </Container>

    <FooterLegal />
  </footer>
</template>

<script setup lang="ts">
  import { useNuxtApp } from '#imports'

  import navigation from '../content/navigation/footer.json'

  const { $event } = useNuxtApp()

  const contactCTA = {
    title: 'Contact us',
    href: '/contact-us'
  }

  const partnersCTA = {
    title: 'For Media',
    href: '/for-media'
  }

  /*   const venturesCTA = {
    title: 'Outfit7 Joint Ventures',
    href: '/joint-ventures'
  } */

  function handleA11Click() {
    $event('Link', { props: { Footer: 'https://www.aurion11.com' } })
  }
</script>
